import useKlydoMutation, {
  UseKlydoMutationOptions,
} from "../../../../components/hooks/useKlydoMutation";
import adminApiClient from "../../../../api/admin";

export type SetUserPasswordInput = {
  userId: string;
  password: string;
};

const useSetPasswordMutation = (
  options?: UseKlydoMutationOptions<void, SetUserPasswordInput>,
) => {
  return useKlydoMutation({
    mutationKey: ["set-user-password"],
    mutationFn: ({ userId, password }: SetUserPasswordInput) =>
      adminApiClient.setUserPassword(userId, password),
    ...options,
  });
};

export default useSetPasswordMutation;
